'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _store = require('linksoft/core/store');

var _store2 = _interopRequireDefault(_store);

var _reducers = require('linksoft/core/reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = (0, _debug2.default)('am:settings');
var SET_SETTINGS = 'SETTINGS_SET';

var api = {
    get: function get() {
        var data = _store2.default.get().getState();
        return data.settings || {};
    },

    set: function set(settings) {
        (0, _store.dispatchAction)({ type: SET_SETTINGS, settings: settings });
    },

    initFromHiddenField: function initFromHiddenField(id) {
        try {
            var element = document.getElementById(id);
            var settings = JSON.parse(element.value);
            api.set(settings);
            element.parentNode.removeChild(element);
        } catch (error) {
            logger(error);
        }
    }
};

exports.default = api;


_reducers2.default.add('settings', function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (action.type === SET_SETTINGS) {
        return _extends({}, state, action.settings);
    }
    return state;
});


//////////////////
// WEBPACK FOOTER
// ./~/linksoft-albatros/src/settings.js
// module id = 254
// module chunks = 0